import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 前端字典数据公共 API（带简易内存缓存）
 *
 * 避免同一页面多个组件同时请求相同字典类型时重复发起 HTTP 请求。
 * 缓存生命周期与页面 JS 运行时相同（刷新页面即失效），不影响后端 Redis 缓存的正确性。
 *
 * 用法：
 *   import { getDictDataByType } from '@/features/components/dict/dict.api';
 *   const list = await getDictDataByType('tool_type');
 *   // list: [{ dictValue, dictLabel, listClass, ... }]
 */

const _cache = {};
const _pending = {};

export function getDictDataByType(dictType) {
  if (!dictType) return Promise.resolve([]);

  // 命中内存缓存直接返回
  if (_cache[dictType]) {
    return Promise.resolve(_cache[dictType]);
  }

  // 防止并发重复请求同一 dictType（如页面多个 DictSelect 同时挂载）
  if (_pending[dictType]) {
    return _pending[dictType];
  }

  const request = axios
    .get(`${iffApi}/dict/data/type/${dictType}`)
    .then((res) => {
      const data = res.data || [];
      _cache[dictType] = data;
      delete _pending[dictType];
      return data;
    })
    .catch((err) => {
      delete _pending[dictType];
      throw err;
    });

  _pending[dictType] = request;
  return request;
}

/** 手动清除某个类型的前端缓存（如管理端修改字典后需同步刷新） */
export function clearDictCache(dictType) {
  if (dictType) {
    delete _cache[dictType];
  } else {
    Object.keys(_cache).forEach((k) => delete _cache[k]);
  }
}
